import React from "react";
import styled from "styled-components/macro";
import { Button, Stack, Backdrop, Paper } from "@mui/material";
import { Trans } from "react-i18next";
import { useSetState } from "components/ReduxProvider";
import { sourceQuery$data } from "queries/sources/__generated__/sourceQuery.graphql";
import { devicePaddings } from "tools/device";
import { dispatchEvent, EVENT } from "tools/events";
import { useEffectOnce } from "react-use";
import { useNavigate } from "react-router-dom";

const SPaper = styled(Paper)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px 24px ${({ theme }) => 32 + devicePaddings().bottom}px;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1);
`;

const Message = styled.div`
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

type Props = {
  source: NonNullable<sourceQuery$data["sourceByUriOrId"]>;
};

const GuestLoginPrompt: React.FC<Props> = ({ source }) => {
  const setLinkedSource = useSetState("linkedSource");
  const navigate = useNavigate();

  useEffectOnce(() => {
    dispatchEvent(EVENT.playVideo, false);
  });

  const handleGetStarted = () => {
    setLinkedSource({ id: source.id, title: source.name, uri: source.uri, lang: source.lang as string });
    navigate("/");
  };

  return (
    <Backdrop open sx={{ backgroundColor: "rgba(0, 0, 0, 0.15)" }}>
      <SPaper>
        <Stack spacing={2} alignItems="center" sx={{ maxWidth: "500px", margin: "0 auto" }}>
          <Message>
            <Trans>To start learning, sign up for free.</Trans>
          </Message>
          <Button variant="contained" color="primary" size="large" onClick={handleGetStarted} fullWidth>
            <Trans>Get started</Trans>
          </Button>
        </Stack>
      </SPaper>
    </Backdrop>
  );
};

export default GuestLoginPrompt;
